import { tempate_1 } from './template_1'

export { tempate_1 }
